import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import "../styles/CTASection.css";
import handsImg from "../assets/image/solidarity_hands.png";
import decorImg from "../assets/image/decor.png";

function CTASection() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="cta-section">
      <div className="cta-container">
        {/* Illustration des mains à gauche */}
        <div className="cta-image-left">
          <img src={handsImg} alt="Engagement communautaire" />
        </div>

        {/* Contenu textuel */}
        <div className="cta-content">
          <h2 className="cta-title">{t('cta.title')}</h2>
          <p className="cta-subtitle">
            {t('cta.subtitle')}
          </p>
          <div className="cta-buttons">
            <button className="btn-cta btn-black" onClick={() => navigate('/partners')}>
              {t('cta.btnPartner')}
            </button>
            <button className="btn-cta btn-outline-white" onClick={() => navigate('/contact')}>
              {t('cta.btnContact')}
            </button>
          </div>
        </div>

        <div className="cta-illustration-right">
          <img src={decorImg} alt="Décoration montagne" />
        </div>
      </div>
    </section>
  );
}

export default CTASection;
